import { Outlet } from '@tanstack/react-router';
import React, { ReactElement } from 'react';

function CollectionsContainer(): ReactElement {
  return <Outlet />;
}

export default CollectionsContainer;
